import { createFileRoute } from '@tanstack/react-router'
import { auth } from '../hooks/beforeLoad/auth'
import LoadingScreen from '../LoadingScreen/LoadingScreen'
import React from 'react'
import CenteredPage from '../../views/styled/CenteredPage/CenteredPage'
import VehicleWindow from '../../components/VehicleWindow/VehicleWindow'

export const Route = createFileRoute('/test')({
  beforeLoad: auth,
  component: RouteComponent,
  pendingComponent: () => <LoadingScreen />,
  loader: async ({ context }) => {
    const label = 'index.tsx loader'
    console.time(label)
    const { client, queryClient } = context
    console.timeEnd(label)
    return {}
  }
})

function RouteComponent() {
  return (
    <CenteredPage>
      <VehicleWindow />
    </CenteredPage>
  )
}
